module.exports = __webpack_public_path__ + "img/calendar.25910009.png";